<div class="form-container" *ngIf="addGuestForm">
    <div class="header-container">
        <h5>{{ title }}</h5>
        <div class="action-buttons">
            <button type="button"
                    class="button secondary"
                    (click)="cancelGuest()">
                Cancel
            </button>
            <button
                type="button"
                class="button primary add-button"
                [disabled]="isAddAvailable"
                (click)="submit()">
                {{ buttonSubmitTitle }}
            </button>
        </div>
    </div>
    <div class="add-guest-container">
        <div class="photo-upload-container" *ngIf="!isBadgeExtension">
            <img [src]="photoData? this.userPhotoUrl : defaultImageUrl" alt="" class="photo-preview">
            <span class="info-row">
                Photo guide
                <employee-info-hint [isHTML]="true" infoText="
                     <div>
                        <strong> Please, follow the rules for a better result </strong>
                        <div> 1.Jpeg/jpg format</div>
                        <div> 2. Forward-facing with your entire face, head, shoulders, and eyes completely visible</div>
                        <div> 3. Clear, well-lit photo of only you</div>
                        <div> 4. Plain white or off-white background</div>
                        <div> 5. No sunglasses or hats</div>
                        <div> 6. No black and white photos</div>
                        <div> 7. Maximum size of file is 10 Mbs</div>
                    </div>">
                </employee-info-hint>
            </span>
            <ui-upload-photo
                [uploadConfig]="uploadConfig"
                [buttonType]="'text'"
                [buttonText]="buttonTitle"
                [isVisitorRequest]="true"
                (onUploadPhoto)="onPhotoUploaded($event)">
            </ui-upload-photo>
        </div>

        <div [formGroup]="addGuestForm" class="add-guest-inputs">
            <div class="input-container">
                <div class="input-block">
                    <employee-visitor-type *ngIf="showVisitorType"  (visitorTypeChange)="onTypeOfVisit()"></employee-visitor-type>
                </div>

                <div class="input-block" *ngIf="isPurposeVisible">
                    <employee-visit-reason
                        [reasons]="purposeOfVisitList"
                        (visitReasonChange)="handleIRCApproverShown()"
                        controlKey="purposeOfVisit"
                    ></employee-visit-reason>
                </div>
                <employee-request-input
                    title="First name"
                    formControlName="firstName"></employee-request-input>
                <employee-request-input
                    title="Last name"
                    formControlName="lastName"></employee-request-input>
                @if (guestFormType === GuestFormType.EDIT) {
                    <div class="input-block">
                        <strong>Mobile number</strong>
                        <div class="edit-mobile-row">
                            <span class="edit-mobile-prefix">+91-</span>
                            <input
                                class="edit-mobile-input"
                                type="text"
                                inputmode="numeric"
                                maxlength="12"
                                placeholder="0000000000"
                                formControlName="localCellNumber"
                                [class.invalid]="addGuestForm.controls.localCellNumber.invalid && addGuestForm.controls.localCellNumber.touched">
                        </div>
                        <div class="error-message" *ngIf="addGuestForm.controls.localCellNumber.invalid && addGuestForm.controls.localCellNumber.touched">
                            <span *ngIf="addGuestForm.controls.localCellNumber.errors?.required">Required</span>
                            <span *ngIf="addGuestForm.controls.localCellNumber.errors?.pattern">Invalid phone format</span>
                        </div>
                    </div>
                } @else {
                    <employee-request-input
                        title="Mobile number"
                        mask="0000-0000-00"
                        prefix="+91-"
                        placeholder="+91-0000-0000-00"
                        formControlName="localCellNumber"></employee-request-input>
                }
                <employee-request-input
                    title="Email"
                    type="email"
                    formControlName="email"></employee-request-input>

                <employee-request-input
                    title="Company"
                    formControlName="companyName"></employee-request-input>
                <employee-request-input
                    *ngIf="isBadgeExtension"
                    title="Badge Number"
                    formControlName="cardNumber"
                    [maxLength]="20"
                    maskPhoneErrText="Only numbers are allowed"></employee-request-input>
            </div>
            <div class="input-container">
                <div class="input-block">
                    <employee-access-required [controlKey]="'accessRequiredIds'" (accessRequiredChange)="onAccessRequiredChange($event)"></employee-access-required>
                </div>

               
            </div>

            <div class="input-container">

                <div class="grid-item">
                    <div class="input-block">
                        <employee-approvers
                            [title]="'Approver(sr. manager and above)'"
                            [selectedApprovers]="addGuestForm?.value?.approversFull"
                            [isFunctionRequired]="false"
                            [employeeFunctionId]="addGuestForm?.value?.entityOrFssId"
                            [requestCategory]="BadgeRequestCategoryEnum.NonDeloitte"
                            [disabled]="isSeniorManager"
                            (approversChanged)="setApprovers($event)"
                            (approversFullChanged)="setFullApprovers($event)"
                        ></employee-approvers>
                    </div>
                </div>

                <div class="input-block">
                    <strong>Visitor has a laptop</strong>
                    <div class="checkbox">
                        <input type="checkbox"
                               formControlName="hasLapTop"
                               (change)="setLaptopValidators()">
                        <div class="checkbox-text">Yes</div>
                    </div>
                </div>
                <ng-container *ngIf="addGuestForm?.value?.hasLapTop">
                    <employee-request-input
                        title="Laptop make"
                        formControlName="laptopMake"></employee-request-input>

                    <employee-request-input
                        title="Laptop serial number"
                        formControlName="laptopSerialNumber"></employee-request-input>
                </ng-container>
            </div>
            <div class="input-container">
                <div class="input-block">
                    <employee-request-input
                        title="Visit start"
                        type="date"
                        minValue="today"
                        formControlName="visitStartDate"
                        (change)="dateChanged()"
                    ></employee-request-input>
                </div>
                <div class="input-block">
                    <employee-request-input
                        title="Visit end"
                        type="date"
                        [disabled]="!minDate"
                        [minValue]="minDate"
                        [noOfDays]="DisplayDate"
                        (change)="dateChanged()"
                        formControlName="visitEndDate"></employee-request-input>
                </div>
                <div class="input-block">
    <p class="mb-4">
        <strong>Attachment </strong><span>(optional)</span>
    </p>
    
    <!-- Upload button - always visible -->
    <ui-upload-photo
        [uploadConfig]="uploadAttachmentConfig"
        [buttonType]="'label'"
        [buttonText]="'Add Attachment'"
        [isVisitorRequest]="true"
        [isAttachment]="true"
        (onUploadPhoto)="onAttachmentUpload($event)"
    >
    </ui-upload-photo>
    
    <!-- List of attachments -->
    <div class="attachments-list" *ngIf="attachmentsList.length > 0">
        <div class="attachment-container" *ngFor="let attachment of attachmentsList; let i = index">
            <span class="attachment-title ellipsis">{{ attachment.name }}</span>
            <div class="secondary-text">
                <span class="attachment-title">{{ attachment.length | fileSize }} </span>
                <i class="icon icon-delete" (click)="clearAttachment(i)" (keydown.enter)="clearAttachment(i)" tabindex="0" role="button"></i>
            </div>
        </div>
    </div>
</div>
            </div>

            <div class="notification-container">
                <employee-request-textarea
                    textHeight="70"
                    title="Comments (optional)"
                    formControlName="notification"></employee-request-textarea>
            </div>


        </div>

    </div>
</div>
